import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Col, Row, Skeleton } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import PageContainer from "../../components/PageContainer";
import MessageItem from "./MessageItem";
import { ReactComponent as EmptyIcon } from "../../images/empty.svg";
import { getMessageListService, postReadMessageService } from "./messages.api";

function Messages() {
  const { state } = useLocation();

  const [messages, setMessages] = useState({
    loading: false,
    contents: [],
  });

  useEffect(() => {
    postReadMessageService().finally();
  }, []);

  useEffect(() => {
    setMessages({ ...messages, loading: true });
    getMessageListService()
      .then((res) => {
        if (res.hasOwnProperty("data") && res.data.hasOwnProperty("content")) {
          if (res.data.content.length)
            setMessages({
              ...messages,
              contents: res.data.content,
              loading: false,
            });
          else
            setMessages({
              ...messages,
              contents: [],
              loading: false,
            });
        }
      })
      .catch((err) => {
        setMessages({ ...messages, contents: undefined, loading: false });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <PageContainer
      classNames="wrap-messages"
      headerProps={{
        right: "",
        left: (
          <NavLink to={state && state.prevPath ? state.prevPath : "/"}>
            <LeftOutlined
              style={{ color: "#ffffff", fontSize: 14, fontWeight: "bold" }}
            />
          </NavLink>
        ),
        content: "پیام‌ها",
      }}
    >
      <Row>
        <Col span={24}>
          {messages.loading ? (
            <>
              <Skeleton active={true} />
              <Skeleton active={true} />
              <Skeleton active={true} />
              <Skeleton active={true} />
            </>
          ) : messages.contents && messages.contents.length ? (
            <div className="list">
              {messages.contents.map((message) => (
                <MessageItem item={message} key={message.id} />
              ))}
            </div>
          ) : (
            <div className="center-flex empty">
              <EmptyIcon className="mb-20" />
              این صفحه خالی است
            </div>
          )}
        </Col>
      </Row>
    </PageContainer>
  );
}

export default Messages;
